(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["b93-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b93-size-guide')) {
    const STORE_KEY = 'b93_size_guide_v1';
    const FIT_NAMES = { tight: 'tæt', normal: 'normal', loose: 'løs' };

    const parseList = (s) => String(s || '').split(/[,;\s]+/).map((x) => x.trim()).filter(Boolean);
    const norm = (s) => String(s || '').trim().toUpperCase();

    class B93SizeGuide extends HTMLElement {
      connectedCallback() {
        const raw = this.querySelector('[data-sg-config]');
        if (!raw) return;
        const cfg = JSON.parse(raw.textContent);
        this.option = cfg.option;
        this.order = parseList(cfg.order).map(norm);
        this.heights = parseList(cfg.heights).map(Number);
        this.weights = parseList(cfg.weights).map(Number);
        this.grid = String(cfg.grid || '').split(/\r?\n/).map((r) => parseList(r).map(norm)).filter((r) => r.length);
        this.tallFrom = Number(cfg.tallFrom) || 0;

        this.dialog = this.querySelector('[data-sg-dialog]');
        this.h = this.querySelector('[data-sg-h]');
        this.w = this.querySelector('[data-sg-w]');

        this.querySelectorAll('[data-sg-open]').forEach((b) => b.addEventListener('click', () => this.open()));
        this.querySelector('[data-sg-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.h.addEventListener('input', () => this.syncOutputs());
        this.w.addEventListener('input', () => this.syncOutputs());
        this.querySelector('[data-sg-show]').addEventListener('click', () => this.showResult());
        this.querySelector('[data-sg-back]').addEventListener('click', () => this.setStep('form'));
        this.querySelector('[data-sg-choose]').addEventListener('click', () => this.choose());

        const saved = this.load();
        if (saved) {
          this.h.value = saved.h;
          this.w.value = saved.w;
          const fitInput = this.querySelector(`input[value="${saved.fit}"]`);
          if (fitInput) fitInput.checked = true;
          this.syncOutputs();
          // Vælg automatisk den anbefalede størrelse for dette produkt
          const rec = this.recommend(saved.h, saved.w, saved.fit);
          if (rec) {
            const ok = this.selectVariant(rec);
            this.showSaved(rec, saved, ok);
          }
        }
      }

      // --- Beregning ---
      sizeIndexAt(h, w) {
        const hi = this.heights.filter((b) => h >= b).length;
        const wi = Math.min(this.weights.filter((b) => w >= b).length, this.grid.length - 1);
        const row = this.grid[wi] || [];
        const cell = row[Math.min(hi, row.length - 1)];
        return this.order.indexOf(cell);
      }
      recommend(h, w, fit) {
        let i = this.sizeIndexAt(h, w);
        if (i < 0) return null;
        if (fit === 'tight') i -= 1;
        if (fit === 'loose') i += 1;
        return this.closestAvailable(i);
      }
      closestAvailable(i) {
        // Vælg nærmeste størrelse, som produktet faktisk har
        const offered = this.inputs().map((x) => norm(x.value));
        const clamp = (n) => Math.max(0, Math.min(this.order.length - 1, n));
        i = clamp(i);
        for (let d = 0; d < this.order.length; d++) {
          for (const j of [i + d, i - d]) {
            if (j >= 0 && j < this.order.length && offered.includes(this.order[j])) return this.order[j];
          }
        }
        return this.order[i];
      }
      alternative(h, w, fit, rec) {
        const probes = [[0, -3], [0, 3], [-3, 0], [3, 0]];
        for (const [dh, dw] of probes) {
          const s = this.recommend(h + dh, w + dw, fit);
          if (s && s !== rec) return s;
        }
        return null;
      }

      // --- Variant-vælgeren (Dwell/Horizon) ---
      inputs() {
        const all = document.querySelectorAll('variant-picker input[type="radio"]');
        return Array.from(all).filter((x) => x.dataset.optionName === this.option);
      }
      findInput(size) {
        return this.inputs().find((x) => norm(x.value) === norm(size));
      }
      isAvailable(input) {
        return input && !input.disabled && input.dataset.optionAvailable !== 'false';
      }
      selectVariant(size) {
        const input = this.findInput(size);
        if (!this.isAvailable(input)) return false;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }

      // --- UI ---
      fit() {
        const c = this.querySelector('.b93-sg__fit input:checked');
        return c ? c.value : 'normal';
      }
      syncOutputs() {
        this.querySelector('[data-sg-h-out]').textContent = `${this.h.value} cm`;
        this.querySelector('[data-sg-w-out]').textContent = `${this.w.value} kg`;
      }
      setStep(step) {
        this.querySelectorAll('[data-sg-step]').forEach((el) => { el.hidden = el.dataset.sgStep !== step; });
      }
      open() {
        this.setStep('form');
        this.syncOutputs();
        this.dialog.showModal();
      }
      basisText(h, w, fit) {
        return `${h} cm · ${w} kg · ${FIT_NAMES[fit]} pasform`;
      }
      showResult() {
        const h = Number(this.h.value), w = Number(this.w.value), fit = this.fit();
        const rec = this.recommend(h, w, fit);
        if (!rec) return;
        this.current = { rec, h, w, fit };
        this.querySelector('[data-sg-rec]').textContent = rec;
        this.querySelector('[data-sg-rec-text]').textContent = rec;
        this.querySelector('[data-sg-basis]').textContent = `Baseret på ${this.basisText(h, w, fit)}`;

        const alt = this.alternative(h, w, fit, rec);
        const altEl = this.querySelector('[data-sg-alt]');
        altEl.hidden = !alt;
        if (alt) altEl.innerHTML = `Du ligger tæt på grænsen. <strong>${alt}</strong> kan også passe – vælg den største af de to, hvis du vil have mere plads.`;

        this.querySelector('[data-sg-tall]').hidden = !(this.tallFrom && h >= this.tallFrom);

        const available = this.isAvailable(this.findInput(rec));
        const unEl = this.querySelector('[data-sg-unavailable]');
        unEl.hidden = available;
        if (!available) unEl.textContent = `Str. ${rec} er desværre udsolgt lige nu.`;
        const choose = this.querySelector('[data-sg-choose]');
        choose.hidden = !available;
        choose.textContent = `Vælg str. ${rec}`;

        this.setStep('result');
        this.track('size_guide_result', { size: rec, fit });
      }
      choose() {
        if (!this.current) return;
        const { rec, h, w, fit } = this.current;
        const ok = this.selectVariant(rec);
        this.save({ h, w, fit });
        this.showSaved(rec, { h, w, fit }, ok);
        this.dialog.close();
        this.track('size_guide_selected', { size: rec, fit });
      }
      showSaved(rec, s, ok) {
        const box = this.querySelector('[data-sg-saved]');
        this.querySelector('[data-sg-saved-size]').textContent = rec;
        this.querySelector('[data-sg-saved-basis]').textContent = this.basisText(s.h, s.w, s.fit);
        box.hidden = false;
        const so = this.querySelector('[data-sg-soldout]');
        so.hidden = ok;
        if (!ok) so.textContent = `Din størrelse (${rec}) er udsolgt i denne vare.`;
      }

      // --- Hukommelse og måling ---
      load() {
        try { const v = JSON.parse(localStorage.getItem(STORE_KEY)); return v && v.h && v.w ? v : null; } catch (e) { return null; }
      }
      save(v) {
        try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) { /* privat vindue – ignorer */ }
      }
      track(name, data) {
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) { /* ignorer */ }
      }
    }

    customElements.define('b93-size-guide', B93SizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
